import React, { useState } from "react"
import { Grid } from "../../../../../Common/Grid"
import { Button } from "@fullscreendigital/carrefour-dex-fe"
import { TitleHeader } from "../../../../Common/TitleHeader"
import { useNotification } from "../../../../../../../hooks"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { useMutation } from "react-query"
import { makeCorePostRequest } from "../../../../../../../utils/api"
import { formatErrorMessage } from "../../../../../../../utils/formatting"
import ImageUpload from "../../../../Common/ImageUpload/ImageUpload"
import { Typography } from "@mui/material"

const NoticeUpload = () => {
  const { showNotification } = useNotification()
  const navigate = useNavigate()
  const { id: orderId } = useParams<{ id: string }>()
  const [sp] = useSearchParams()
  const supplierCode = sp.get("supplierCode")

  const [uploadedCount, setUploadedCount] = useState(0)

  const {
    mutate: finalizeOrder,
    isLoading: isFinalizing,
  } = useMutation(
    async () => {
      return await makeCorePostRequest(
        `/shop-reception-mobile/ds-order/finalize/${orderId}/${supplierCode}`,
        null
      )
    },
    {
      onSuccess: () => {
        showNotification({
          message: "Receptia a fost finalizat cu succes.",
          type: "success",
        })
        navigate("/goodsReception/suppliers")
      },
      onError: (error: unknown) => {
        showNotification({
          message: `Eroare la finalizarea receptia: ${formatErrorMessage(error)}`,
          type: "error",
        })
      },
    }
  )

  const handleUploadSuccess = () => {
    setUploadedCount((prev) => prev + 1)

    showNotification({
      message: "Imaginea a fost încărcată cu succes.",
      type: "success",
    })
  }

  const handleUploadError = (error: unknown) => {
    showNotification({
      message: `Eroare la încărcarea imaginii: ${formatErrorMessage(error)}`,
      type: "error",
    })
  }

  const items = [
    <TitleHeader key="title" title="INCARCARE AVIZ" />,
    <div
      key="upload-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 32,
        paddingInline: 16,
      }}
    >
      <Typography
        variant="subtitle1"
        component="p"
        sx={{ fontWeight: 600, textTransform: "uppercase", marginBottom: 1 }}
      >
        Încărcare aviz
      </Typography>

      <Typography
        variant="body2"
        component="p"
        sx={{ textAlign: "center", marginBottom: 2 }}
      >
        Fă o poză avizului sau încarcă o imagine din galerie.
      </Typography>

      <Typography
        variant="body2"
        component="p"
        sx={{ textAlign: "center", marginBottom: 2, fontWeight: 600 }}
      >
        {uploadedCount > 0
          ? `Imagini încărcate: ${uploadedCount}`
          : "Nu ai încărcat încă nicio imagine."}
      </Typography>

      <ImageUpload
        uploadUrl={`/shop-reception-mobile/ds-order/upload-notice-picture/${orderId}/${supplierCode}`}
        onSuccess={handleUploadSuccess}
        onError={handleUploadError}
      />
    </div>,

    uploadedCount > 0 && (
      <Button
        key="finalize"
        type="button"
        variant="contained"
        label={
          isFinalizing
            ? "Se finalizează..."
            : `Finalizează receptia (${uploadedCount})`
        }
        onClick={() => finalizeOrder()}
        disabled={isFinalizing}
        style={{ width: "100%" }}
      />
    ),
  ].filter(Boolean)

  return (
    <Grid
      gridContainerStyle={{ marginTop: "20px" }}
      itemsPerRow={1}
      items={items}
    />
  )
}

export default NoticeUpload
